import { Moment } from 'moment';
import PartsOrderStatus from '@/dossier/constants/PartsOrderStatus';
import VehicleStatus from '@/dossier/constants/VehicleStatus';
import WorkStatus from '@/dossier/constants/WorkStatus';
import { DossierId } from '@/dossier/models/AbstractDossier';

export default class TaskDossier {
  id!: DossierId;
  waitsOnPremise!: boolean;
  workStatus: WorkStatus | null = null;
  vehicleStatus: VehicleStatus | null = null;
  partsOrderStatus: PartsOrderStatus | null = null;
  checkedInAt: Moment | null = null;
  checkedOutAt: Moment | null = null;
  pickUpAt: Moment | null = null;

  isCustomerWaiting(): boolean {
    return this.waitsOnPremise || this.pickUpAt != null;
  }

  static withId(id: DossierId): TaskDossier {
    const dossier = new TaskDossier();
    dossier.id = id;
    return dossier;
  }
}